import { gql } from '@apollo/client'

// Curry Me Club programme administration (loyalty.manage).
//
// Every field of LoyaltyProgram and of its ladder in one fragment: each of the
// nine programme mutations returns the WHOLE programme, so re-selecting these
// fields there lets Apollo's normalized cache refresh the editor without a
// refetch. `params_json` is the JSON scalar — the shape depends on the rung's
// reward_type (see src/types/loyalty.ts).
export const LOYALTY_PROGRAM_FIELDS = gql`
  fragment LoyaltyProgramFields on LoyaltyProgram {
    id
    name
    status
    starts_at
    ends_at
    card_size
    min_order_cents
    max_stamps_per_day
    claim_ttl_days
    is_current
    published_at
    cloned_from_id
    tiers {
      id
      program_id
      trigger
      threshold
      reward_type
      params_json
      validity_days
      name_nl
      name_en
      sort_order
      active
    }
    created_at
    updated_at
  }
`

/** Every programme, newest start first, with its ladder. */
export const GET_LOYALTY_PROGRAMS = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  query GetLoyaltyPrograms {
    loyaltyPrograms {
      ...LoyaltyProgramFields
    }
  }
`

/** One programme with its ladder, or null when the id is unknown. */
export const GET_LOYALTY_PROGRAM = gql`
  ${LOYALTY_PROGRAM_FIELDS}
  query GetLoyaltyProgram($id: ID!) {
    loyaltyProgram(id: $id) {
      ...LoyaltyProgramFields
    }
  }
`
